import actionTypes from '../constants/action-types';

const deleteCustomFontPair = (id) => ({
  type: actionTypes.DELETE_CUSTOM_FONT_PAIR,
  payload: {
    id,
  },
});

export default deleteCustomFontPair;
